// LIGE (2026-11-03) : une diapositive cachée (aria-hidden="true") reçoit inert,
// pour que ni le clavier ni les lecteurs d'écran n'atteignent ses liens.
// Chargé en module depuis snippets/slideshow.liquid : exécuté une seule fois.
// Ne relit que les diapositives touchées, pas toutes celles de la page à
// chaque nœud ajouté n'importe où dans le document.
const sync = (slide) => {
  if (slide.getAttribute('aria-hidden') === 'true') {
    if (!slide.hasAttribute('inert')) slide.setAttribute('inert', '');
  } else if (slide.hasAttribute('inert')) {
    slide.removeAttribute('inert');
  }
};

const syncWithin = (root) => root.querySelectorAll('slideshow-slide').forEach(sync);

syncWithin(document);

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'attributes') {
      if (mutation.target.localName === 'slideshow-slide') sync(mutation.target);
      continue;
    }
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== Node.ELEMENT_NODE) continue;
      if (node.localName === 'slideshow-slide') sync(node);
      else if (node.firstElementChild) syncWithin(node);
    }
  }
}).observe(document.documentElement, {
  subtree: true,
  childList: true,
  attributes: true,
  attributeFilter: ['aria-hidden'],
});
